import * as exElement from '../element';

import arrayBufferToUrl from './arrayBufferToUrl';

// ----------------------------------------------------------------------------

async function arrayBufferToImage(arrayBuffer: ArrayBuffer, config: Record<string, any> = {}): Promise<any> {
    // New Promise
    const promise = new Promise(function (resolve, reject): any {
        const url = arrayBufferToUrl(arrayBuffer);
        const urlCreator = window.URL || window.webkitURL;

        // Create element (image)
        const elImage = exElement.create({
            merge: config,
            tag: 'img',
        }) as HTMLImageElement;

        // Create event (load)
        elImage.addEventListener('load', function (evt): any {
            resolve(evt.target);
            urlCreator.revokeObjectURL(url);
        });
        // Create event (error)
        elImage.addEventListener('error', function (err): any {
            urlCreator.revokeObjectURL(url);
            reject(err);
        });

        // Set source
        elImage.src = url;
    });

    // Return
    return promise;
}

// ----------------------------------------------------------------------------

export default arrayBufferToImage;
